import styled from 'styled-components';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { NavLink } from 'react-router-dom';

export const MainWrapper = styled.div`
  display: ${({ show }) => (show === 'true' ? 'flex' : 'none')};
  width: 100%;
  height: 4rem;
  background-color: transparent;
  font-family: 'Montserrat', sans-serif;

  /* General breakpoint for mobile devices */
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export const LogoWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  -webkit-align-items: center;
  margin-left: 5rem;
  width: 20%;

  /* General breakpoint for mobile devices */
  @media only screen and (max-width: 768px) {
    width: auto;
    margin-left: 0;
  }
`;

export const LinkWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  width: 60%;

  /* General breakpoint for mobile devices */
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    width: auto;
    align-items: flex-start;
    -webkit-align-items: flex-start;
  }
`;

export const AuthWrapper = styled.div`
  display: inline-flex;
  justify-content: flex-end;
  -webkit-justify-content: flex-end;
  align-items: center;
  -webkit-align-items: center;
  margin-right: 5rem;
  width: 20%;

  /* General breakpoint for mobile devices */
  @media only screen and (max-width: 768px) {
    margin: 1rem 0.5rem;
    width: 100%;

    button {
      height: 2.5rem !important;
      width: calc(100% - 2rem) !important;
    }
  }
`;

export const LogoImg = styled.img`
  width: 3rem;
  height: 3rem;
  cursor: pointer;
`;

export const H1 = styled.h1`
  font-size: 1.4rem;
`;

export const IconLink = styled(NavLink)`
  display: flex;
  align-items: center;
  -webkit-align-items: center;
  max-width: 16rem;
  max-height: 4rem;
  text-decoration: none;
  margin: 0 0.5rem;

  /* General breakpoint for mobile devices */
  @media only screen and (max-width: 768px) {
    :nth-child(1) {
      margin: 1rem;
    }
    :nth-child(2) {
      margin: 0 1rem 1rem 1rem;
    }
    :nth-child(3) {
      margin: 0 1rem 1rem 1rem;
    }
  }
`;

export const IconImg = styled.img`
  width: 2rem;
  height: 2rem;
`;

export const IconText = styled.span`
  font-size: 1.1rem;
  color: ${({ active }) => (active ? '#f3c314' : '#bdc3c7')};
  font-weight: 700;

  /* General breakpoint for mobile devices */
  @media only screen and (max-width: 768px) {
    margin: 0 0.5rem;
  }
`;

export const HorizontalDivider = styled.div`
  width: 1.5px;
  height: 2rem;
  background-color: #bdc3c7;
  margin: 0.5rem;
`;

export const AvatarTooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  -webkit-align-items: center;
  :hover {
    cursor: pointer;
  }
`;

export const AuthIcon = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  opacity: 0.9;
`;

export const UserAvatarImg = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  border: 2px solid #f3c314;
  box-sizing: border-box;
`;

export const ArrowIcon = styled.img`
  width: 2.5rem;
  height: 2.5rem;
  margin-top: 0.25rem;
  opacity: 0.9;
`;

export const MobileMainWrapper = styled.div`
  display: none;

  /* General breakpoint for mobile devices */
  @media only screen and (max-width: 768px) {
    display: ${({ show }) => (show === 'true' ? 'flex' : 'none')};
  }
`;

export const BurgerBlock = styled.div`
  display: inherit;
  width: ${({ userData }) => (userData ? 'auto' : '100%')};
  justify-content: ${({ userData }) => (userData ? 'flex-start' : 'flex-end')};
  -webkit-justify-content: ${({ userData }) => (userData ? 'flex-start' : 'flex-end')};
  align-items: center;
  -webkit-align-items: center;
`;

export const BurgerImg = styled.img`
  width: 3rem;
  height: 2rem;
  margin-right: 0.5rem;
`;

export const MobileDrawer = styled(SwipeableDrawer)`
  display: none;

  /* General breakpoint for mobile devices */
  @media only screen and (max-width: 768px) {
    display: ${({ show }) => (show === 'true' ? 'flex' : 'none')};
  }
`;

export const ExpansionSummaryText = styled.span`
  color: #bdc3c7;
  font-size: 1.1rem;
  font-weight: 700;
`;
